import * as index from '@syncfusion/ej2-inplace-editor';
index.InPlaceEditor.Inject( index.AutoComplete,index.ColorPicker,index.ComboBox,index.DateRangePicker,index.MultiSelect,index.Rte,index.Slider,index.TimePicker);
export * from '@syncfusion/ej2-inplace-editor';
